module.exports = __webpack_public_path__ + "img/icon-tracker-gray-light.b8d204c1.svg";